import apiClient from "./config";

const newsCategoryService = {
  // Get all news categories
  getAllCategories: async () => {
    try {
      const response = await apiClient.get("/news-categories");
      console.log("News categories response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in getAllCategories:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch categories"
      );
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await apiClient.get(`/news-categories/${categoryId}`);
      console.log("News category details response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in getCategoryById:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch category details"
      );
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await apiClient.post("/news-categories", categoryData);
      console.log("Create category response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in createCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to create category"
      );
    }
  },

  // Update category
  updateCategory: async (categoryId, categoryData) => {
    try {
      const response = await apiClient.put(
        `/news-categories/${categoryId}`,
        categoryData
      );
      console.log("Update category response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in updateCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to update category"
      );
    }
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    try {
      const response = await apiClient.delete(`/news-categories/${categoryId}`);
      console.log("Delete category response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in deleteCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to delete category"
      );
    }
  },
};

export default newsCategoryService;
